/// <reference path="../../../../../shared/models/generated/MitgliedschaftAnlageResponseApi.d.ts"/>
import { AppFormModel } from '../models/AppFormModel';
import { ContractInfoApi } from '../../../../../shared/models/generated/PersonContractInfoApi';
import { ModelAdapter } from '../../../../../shared/models/adapter/ModelAdapter';
import { BehindertenausweisApi } from '../../../../../shared/models/generated/MitgliedschaftBehindertenausweisApi';
import { BehindertenausweisModel } from '../../../../../shared/models/api/Behindertenausweis';
import { MglAdapter } from '../../../../../shared/models/adapter/MglAdapter';
import { KindApi } from '../../../../../shared/models/generated/MitgliedschaftKindApi';
import { BankApi } from '../../../../../shared/models/generated/PersonBankApi';
import { MglBasisAnlage } from '../../../../../shared/models/api/MglBasisAnlage';
import { MglAnlage } from '../../../../../shared/models/api/MglAnlage';
import { MglAnlageYoungGeneration } from '../../../../../shared/models/api/MglAnlageYoungGeneration';
import { MglAnlageProfiWerber } from '../../../../../shared/models/api/MglAnlageProfiWerber';
import { PersonalDataModel } from '../../../../../shared/models/view/PersonalData';
import { MitgliedschaftGutscheinKooperationApi } from '../../../../../shared/models/generated/MitgliedschaftMitgliedschaftGutscheinKooperationApi';
import { ProfiwerberViewModelApi } from '../../../../../shared/models/generated/MitgliedschaftProfiwerberViewModelApi';
import { EmpfehlungsantragVermerkenRequestApi } from '../../../../../shared/models/generated/FreundschaftsWerbungEmpfehlungsantragVermerkenRequestApi';
import { MitgliedschaftPdfBestaetigungV2Api } from '../../../../../shared/models/generated/MitgliedschaftMitgliedschaftPdfBestaetigungV2Api';
import { ModulKreditkartenFarbeApi } from '../../../../../shared/models/generated/ModulKreditkarteModulKreditkartenFarbeApi';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { ContractInfo } from '../../../../../shared/models/api/User/ContractInfo';
import { AdvertisingConsentModel } from '../../../../../shared/models/view/AdvertisingConsent';
import { CcmConfiguratorModel } from '../../../../../shared/models/api/CcmConfiguratorModel';
import { AppUtils } from '../../../../../shared/utils/index';

/**
 * Converts insurance view models to api models and vice versa.
 */
export class AppModelAdapter extends MglAdapter {

	static readonly YOUNG_GENERATION_RATES = ["J1", "48", "E17", "47", "EN1", "29", "E1", "23", "R1", "42", "33", "EC1"];
	static readonly YOUNG_GENERATION_NOVICE_DRIVER_RATES = ["EN2", "EN4"];

	static readonly dateformat = "DD.MM.YYYY";

	/**
	 * Converts a view model to an api model.
	 *
	 */
	public static getAnlageApi(formModel: AppFormModel,
		advertisingConsent: AdvertisingConsentModel,
		tarif: ContractInfoApi,
		bankdaten: BankApi,
		options: MglModularSystemV2AppOptions,
		withFamilyMembers: boolean,
		onlySimulate: boolean): MglBasisAnlage {
		let requestModel: MglBasisAnlage;

		if (options.app.issalesman) {
			requestModel = new MglAnlageProfiWerber();
		} else if (AppModelAdapter.isYoungGenerationRate(options.app.rate)) {
			requestModel = new MglAnlageYoungGeneration();
		} else {
			requestModel = new MglAnlage();
		}
		requestModel.Tarif = tarif.Tarif;

		if (formModel.MitgliedschaftStartDatum !== "") {
			requestModel.Beginn = formModel.MitgliedschaftStartDatum;
		}

		if (formModel.InAusbildung) {
			requestModel.InAusbildung = true;
			requestModel.Ausbildungsende = formModel.Ausbildungsende;
		} else {
			requestModel.InAusbildung = false;
		}

		//Fake-Ausbildungsende an das Bestandssytem
		//Monat = aktueller Monat (bei Antragsstellung) (aktuell z.B. 10 für Oktober)
		//Jahr = aktuelles Jahr (z.B. 2018) + 1 Jahr (also in diesem Fall 2019)
		if (tarif && tarif.TarifCode === 'E17') {
			requestModel.InAusbildung = true;
			requestModel.Ausbildungsende = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString();
		}
		if (onlySimulate) {
			requestModel.Antragssteller = ModelAdapter.getAntragsstellerApi(formModel.Antragssteller);

		} else {
			requestModel.Antragssteller = ModelAdapter.getAntragsstellerApi(formModel.Antragssteller);
			if (advertisingConsent) {
				requestModel.Consent = ModelAdapter.getConsentWriteShortModelApi(advertisingConsent, formModel.Antragssteller, options.app.originindicator, formModel.AdvertisingVersion);
			}
		}
		if (advertisingConsent) {
			requestModel.Consent.Version = formModel.AdvertisingVersion;
		}

		requestModel.BestimmungenAkzepiert = true;
		requestModel.WiderrufAkzeptiert = true;
		requestModel.Bankdaten = bankdaten;
		if (formModel.Validierungscode) {
			requestModel.Validierungscode = formModel.Validierungscode;
		}
		requestModel.Werbeschluessel = formModel.Werbeschluessel ? formModel.Werbeschluessel : (options.app.advertisingkey ? Number(options.app.advertisingkey) : undefined);

		if (formModel.DigitaleClubkarte) {
			if (requestModel.Werbeschluessel === 7001) {
				requestModel.Werbeschluessel = 1450;
			} else if (requestModel.Werbeschluessel === 1076) {
				requestModel.Werbeschluessel = 1451;
			}
		}

		if (formModel.Bonus.Bonuscode) {
			requestModel.Gutscheindaten = new MitgliedschaftGutscheinKooperationApi({
				Code: formModel.Bonus.Bonuscode,
				EmailKooperation: formModel.Bonus.EmailBonus,
				Gutscheinwert: formModel.Bonus.TextBonus
			});
		}

		if (formModel.BisherigeMitgliedsnummer) {
			requestModel.BisherigeMitgliedsnummer = formModel.BisherigeMitgliedsnummer;
		}

		if (requestModel instanceof MglAnlage) {
			this.SetMglAnlageData(formModel, requestModel, withFamilyMembers);
		}

		if (requestModel instanceof MglAnlageProfiWerber) {
			requestModel.Profiwerbernummer = (formModel.Profiwerbernummer && formModel.Profiwerbernummer.length > 0) ? formModel.Profiwerbernummer : options.app.salesmannumberdefaultvalue;
			requestModel.Pruefziffer = formModel.Pruefziffer;
		}
		return requestModel;
	}

	private static SetMglAnlageData(formModel: AppFormModel, requestModel: MglAnlage, withFamilyMembers: boolean): void {
		requestModel.Motorweltverzicht = formModel.Motorweltverzicht;
		if (formModel.IstSchwerbehindert) {
			requestModel.IstSchwerbehindert = true;
			requestModel.Behindertenausweis = this.getBehindertenausweisApi(formModel.Behindertenausweis);
		} else {
			requestModel.IstSchwerbehindert = false;
		}

		requestModel.HatKinder = withFamilyMembers && formModel.Kinder && formModel.Kinder.length > 0;
		requestModel.Kinder = new Array<KindApi>();

		if (withFamilyMembers) {
			if (formModel.Partner) {
				requestModel.HatPartner = true;
				requestModel.Partner = this.getPartnerApi(formModel.Partner);
			}

			if (requestModel.HatKinder) {
				for (const child of formModel.Kinder) {
					requestModel.Kinder.push(this.getKindApi(child));
				}
			}
		}
	}

	public static setRecommendationDataToRequestModel(reqModel: MglBasisAnlage, recommendationData: EmpfehlungsdatenResponseApi): void {
		reqModel.Agenturnummer = null;
		if (reqModel instanceof MglAnlage) {
			reqModel.Werbernummer = Number(recommendationData.Mitgliedsnummer);
			reqModel.Werbegeschenk = Number(recommendationData.Praemiennummer);
			if (!AppUtils.Helper.isEmptyString(recommendationData.Werbeschluessel)) {
				reqModel.Werbeschluessel = Number(recommendationData.Werbeschluessel);
			}
		}
	}

	public static getProfiwerberApi(formModel: AppFormModel, werbeschluessel: string): ProfiwerberViewModelApi {
		const result = new ProfiwerberViewModelApi();
		result.Profiwerbernummer = formModel.Profiwerbernummer;
		result.Pruefziffer = formModel.Pruefziffer;
		result.Werbeschluessel = Number(werbeschluessel);

		return result;
	}

	public static isYoungGenerationRate(rate: string): boolean {
		return -1 < AppModelAdapter.YOUNG_GENERATION_RATES.indexOf(rate);
	}

	public static isYoungGenerationNoviceDriverLicense(rate: string): boolean {
		return -1 < AppModelAdapter.YOUNG_GENERATION_NOVICE_DRIVER_RATES.indexOf(rate);
	}

	private static getBehindertenausweisApi(model: BehindertenausweisModel): BehindertenausweisApi {
		const result = new BehindertenausweisApi();
		result.Grad = model.Grad;
		result.Nummer = model.Nummer;
		return result;
	}

	public static mergeAntragssteller(successResponse: AnlageResponseApi, antragsstellerForm: PersonalDataModel): { [key: string]: any } {
		return {
			Mitgliedsnummer: successResponse.Mitgliedsnummer,
			AnredeKennzeichen: successResponse.Anrede || antragsstellerForm.AnredeKennzeichen,
			Titel: successResponse.Titel,
			Vorname: successResponse.Vorname || antragsstellerForm.Vorname,
			Nachname: successResponse.Nachname || antragsstellerForm.Nachname,
			Adresse: successResponse.Anschrift || antragsstellerForm.Adresse,
			Geburtsdatum: successResponse.Geburtsdatum || antragsstellerForm.Geburtsdatum,
			TelefonVorwahl: successResponse.Telefon ? successResponse.Telefon.Prefix : antragsstellerForm.TelefonVorwahl,
			TelefonNummer: successResponse.Telefon ? successResponse.Telefon.Suffix : antragsstellerForm.TelefonNummer,
			TelefonGeschaeftlichVorwahl: successResponse.TelGesch ? successResponse.TelGesch.Prefix : antragsstellerForm.TelefonGeschaeftlichVorwahl,
			TelefonGeschaeftlichNummer: successResponse.TelGesch ? successResponse.TelGesch.Suffix : antragsstellerForm.TelefonGeschaeftlichNummer,
			Email: successResponse.Email || antragsstellerForm.Email
		};
	}

	public static getStartOfMembershipDate(beginFieldVal: string): string {
		let beginDate;
		let startDateIso = AppUtils.Format.viewDateToIsoDate(moment(new Date()).format(this.dateformat));

		if (beginFieldVal !== "") {
			const currentDay = moment(new Date()).date();
			const split = beginFieldVal.split(".");
			if (split.length === 3) {
				beginDate = moment(`${currentDay}.${split[1]}.${split[2]}`, this.dateformat);

				// if date is invalid e.g. 31.02.2025, fallback to last day of month
				if (!beginDate.isValid() || beginDate.month() + 1 !== parseInt(split[1])) {
					beginDate = moment(`${split[2]}.${split[1]}`, "YYYY.MM").endOf('month');
				}
			} else {
				beginDate = moment(`${currentDay}.${split[0]}.${split[1]}`, this.dateformat);
				// if date is invalid e.g. 31.02.2025, fallback to last day of month
				if (!beginDate.isValid() || beginDate.month() + 1 !== parseInt(split[0])) {
					beginDate = moment(`${split[1]}.${split[0]}`, "YYYY.MM").endOf('month');
				}
			}

			startDateIso = AppUtils.Format.viewDateToIsoDate(beginDate.format(this.dateformat));
		}

		return startDateIso;
	}

	public static updateEcommerceModel(model: EcommerceBasisPaket, appModel: AppApplicationModel, options: MglModularSystemV2AppOptions): EcommerceBasisPaket {
		const variant = [];
		if (appModel.Tarif.Schwerbehindert) {
			variant.push("Schwerbehindert");
		}
		if (appModel.Tarif.InAusbildung) {
			variant.push("Ausbildung");
		}
		if (appModel.Tarif.HatPartner) {
			variant.push("Partner");
		}
		if (appModel.FormModel.Kinder && appModel.FormModel.Kinder.length > 0) {
			let hasChild = false;
			let hasJuv = false;
			appModel.FormModel.Kinder.forEach((kind) => {
				if (kind.IsJuv) {
					hasJuv = true;
				} else {
					hasChild = true;
				}
			});
			if (hasChild) {
				variant.push("Kind");
			}
			if (hasJuv) {
				variant.push("Juv");
			}
		}

		model.productName = ContractInfo.getDescription(options.app.ratenamemappings, appModel.Tarif.TarifCodeId);
		model.productID = ContractInfo.getDescription(options.app.ratenamemappings, appModel.Tarif.TarifCodeId);
		model.productPrice = appModel.Tarif.Beitrag.toString();
		model.productQty = "1";
		model.productVariant = variant.join(" | ");
		model.productBrand = options.app.ecommercemodel.productbrand;
		model.checkOutPaymentMethod = options.app.ecommercemodel.payment;
		model.contractType = options.app.ecommercemodel.contracttype;
		model.orderTotalPrice = appModel.Tarif.Beitrag.toString();
		model.productType = options.app.ecommercemodel.producttype;
		model.productCategory = options.app.ecommercemodel.productcategory;

		if (model.orderID === undefined || model.orderID.length === 0) {
			model.orderID = options.app.ecommercemodel.orderid;
		}

		return model;
	}

	public static setMailContent(requestModel: MglBasisAnlage, mailText: string, htmlMail: string, subject: string, mailAttachments: string): void {
		if (mailText) {
			requestModel.UserMailText = mailText;
		}
		if (htmlMail) {
			requestModel.IsBodyHtml = true;
			requestModel.MailBodyHtml = htmlMail;

		} else {
			requestModel.IsBodyHtml = false;
		}
		if (mailAttachments) {
			requestModel.Attachments = mailAttachments;
		}
		if (subject) {
			requestModel.Subject = subject;
		}
	}

	public static getConfirmationsMailModel(successResponse: AnlageResponseApi, requiredAttachments: string, mailText: string, htmlMail: string, subject: string, optionalAttachments: string): MitgliedschaftPdfBestaetigungV2Api {
		const result = new MitgliedschaftPdfBestaetigungV2Api();
		result.Email = successResponse.Email;
		result.Attachments = requiredAttachments;
		result.MglToken = successResponse.Token;
		if (mailText) {
			result.UserMailText = mailText;
			result.AttachmentsExt = optionalAttachments;
		}
		if (htmlMail) {
			result.IsBodyHtml = true;
			result.MailBodyHtml = htmlMail;
		} else {
			result.IsBodyHtml = false;
		}

		if (subject) {
			result.Subject = subject;
		}
		return result;
	}

	public static getRecommendationApplicationNoteApiModel(recommendationId: string): EmpfehlungsantragVermerkenRequestApi {
		return new EmpfehlungsantragVermerkenRequestApi({
			EmpfehlungsId: recommendationId
		});
	}

	public static getEncryptionCallParams(
		productKey: string,
		appName: string,
		productAdvertisingkey: string,
		creditCardPackages: CcmConfiguratorModel,
		mglToken?: string,
		pkVid?: string
	): { [key: string]: any } {

		const params: { [key: string]: any } = {
			test: false,
			Produktkennzeichen: productKey,
			AuswahlReise: creditCardPackages.Traveling || false,
			AuswahlSparen: creditCardPackages.Saving || false,
			AuswahlSchutz: creditCardPackages.Protecting || false,
			AuswahlPlatin: creditCardPackages.Platinum || false,
			Werbeschluessel: productAdvertisingkey,
			FarbDesign: (appName === 'AdacPayRefreshApplication' ? ModulKreditkartenFarbeApi.AdacPay : 2)
		};

		if (pkVid) {
			params.TKey = pkVid;
		}

		if (mglToken) {
			params.MglToken = mglToken;
		}

		return params;
	}
}
